import { Action } from '@/react/@types';
import LocalCart from '@/class/LocalCart';
import { calcMontageTotals } from '@/includes/helpers';
export const defStore = {
    cart: [],
};
const cartOrder = ['airduct', 'goods', 'montage'];
function filterByCartType(list, type, not) {
    return list.filter(it => not ? it.type !== type : it.type === type);
}
function sortCart(cart) {
    return cart.sort((a, b) => {
        const pos1 = cartOrder.indexOf(a.type);
        const pos2 = cartOrder.indexOf(b.type);
        if (pos1 > pos2)
            return 1;
        if (pos1 === pos2)
            return 0;
        if (pos1 < pos2)
            return -1;
        return 0;
    });
}
function updateMontageItem(cart) {
    const montage = cart.find(it => it.type === 'montage');
    if (!montage)
        return;
    const { count, square, base, totalPrice } = calcMontageTotals(cart);
    if (montage.type !== 'montage')
        return;
    montage.count = count;
    montage.price = base.toFixed(2);
    montage.square = square.toFixed(3);
    montage.totalPrice = totalPrice.toFixed(2);
}
function updateMontageDataOnReCount(i, cart) {
    var _a;
    if (((_a = cart === null || cart === void 0 ? void 0 : cart[i]) === null || _a === void 0 ? void 0 : _a.type) !== 'airduct')
        return cart;
    updateMontageItem(cart);
    return cart;
}
function updateMontageDataOnChange(cart) {
    return sortCart((() => {
        const airducts = filterByCartType(cart, 'airduct');
        if (airducts.length === 0)
            cart = filterByCartType(cart, 'montage', true);
        else
            updateMontageItem(cart);
        return cart;
    })());
}
function saveLocalCart(cart) {
    LocalCart.save(cart);
    return cart;
}
function reducer(store, action) {
    switch (action.type) {
        case Action.WriteCart: {
            return Object.assign(Object.assign({}, store), { cart: saveLocalCart(updateMontageDataOnChange(action.payload)) });
        }
        case Action.ChangeItem: {
            const { key, index, value } = action.payload;
            return Object.assign(Object.assign({}, store), { cart: saveLocalCart(updateMontageDataOnReCount(index, store.cart.map((it, i) => {
                    return i !== index ? it : Object.assign(Object.assign({}, it), { [key]: value });
                }))) });
        }
        default:
            return store;
    }
}
export const rewriteCart = (payload) => ({
    type: Action.WriteCart, payload,
});
export const changeCartItem = (payload) => ({
    type: Action.ChangeItem, payload,
});
export default reducer;
